import { parseTemplate, renderTemplate } from "./templateEngine";
import { InterpolateArgs } from "../types";

export const interpolate = ({ rawString, context }: InterpolateArgs): string => {
  if (!rawString) return "";
  return renderTemplate(parseTemplate(rawString), context);
};
